import React, { 
  useEffect,
  useState,
  useRef
} from 'react'
import { 
  useParams
} from 'react-router-dom'
import { 
  useGame, 
  useEventData, 
  useUser 
} from 'data/hooks'
import { domToReact } from 'html-react-parser'

export const Dialog = props => {

  const dialogRef = useRef()
  const [current, setCurrent] = useState(false)

  const gameId = useParams().gameId || playmotiv.game.gameId
  const { eventId } = useParams()
  const { events } = useGame(gameId)  
  const event = events[eventId]
  const eventData = useEventData(gameId, eventId, event.instance.instanceId)
  const { 
    updateKpiData
  } = eventData

  useEffect(() => {

    if(dialogRef.current && !current) { 

      const slides = dialogRef.current.getElementsByClassName('dialogslide')
      const buttons = dialogRef.current.getElementsByClassName('wp-block-button__link');

      [].forEach
      .call(
        buttons, 
        button => { 

          button.addEventListener(
            'click',
            e => {

              e.stopPropagation()
              e.preventDefault();
              
              [].forEach
              .call(
                slides,
                slide => {
  
                  slide.className = slide.className.replace('visible', '')
                }
              )
  
              const targetslideid = e.target.getAttribute('href').replace('#', '');
              const targetslide = document.getElementById(targetslideid)
  
              if(targetslide) {
  
                const slidekpis = targetslide.getAttribute('data-slidekpis')

                // TODO -> Check if in event content
  
                if(slidekpis) {

                  const kpis = JSON.parse(slidekpis)

                  updateKpiData(kpis)
                }
  
                targetslide.className += ' visible'
  
              } else {
  
                console.log(targetslideid + ' not found')
              }
            }
          )              
        }
      );
    }

    setCurrent(true)

  }, [dialogRef.current])

  return <div 
    ref={ dialogRef }
    { ...props.attribs }
  >
    { domToReact(props.children) }
  </div>
}